<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    (onBack)="onHidePage()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <div class="app-page-content tw-mx-10 tw-pt-5">
    <!-- content -->
    <div class="app-page-content">
      <div class="tw-w-full tw-flex-center tw-flex-col tw-p-0">
        <!-- helpInformation -->

        <section class="md:tw-w-3/4 tw-w-full">
          <fieldset class="tw-min-w-[1px]">
            <legend>
              {{ model?.menuHelpTitle || "common.help" | translate }}
            </legend>

            @defer (when !loading) {
            <div class="tw-w-full tw-h-full tw-flex-center">
              <div
                class="tw-w-4/5 tw-py-10 tw-leading-10 md:tw-text-[15px] tw-text-[13px] tw-text-justify md:tw-min-h-[60vh] tw-min-h-[50vh]"
                [ngClass]="{
                  ' tw-flex-center':
                    !model?.textHelp && !model?.menuHelps?.length
                }"
              >
                @if(model?.textHelp || model?.menuHelps?.length){

                <!--* Help text -->
                @if(model.textHelp){
                <span
                  [innerHtml]="model?.textHelp | safe : 'html'"
                  class="tw-text-gray-500 dark:tw-text-gray-300 custom-text"
                ></span
                >} } @else {
                <!-- empty -->
                <div class="tw-flex tw-justify-center">
                  <div class="tw-flex-center tw-flex-col">
                    <!-- light -->
                    <img
                      src="/assets/media/svg/help-page/not-help.svg"
                      class="md:tw-w-3/4 dark:tw-hidden tw-block"
                    />

                    <!-- dark -->
                    <img
                      src="/assets/media/svg/help-page/not-help-dark.svg"
                      class="md:tw-w-3/4 dark:tw-block tw-hidden"
                    />
                    <p
                      class="ltr:tw-dir-ltr text-gray tw-dir-rtl tw-font-bold tw-my-5 tw-pt-6 tw-text-2xl tw-text-center tw-text-primary-600 dark:tw-text-primary-200"
                    >
                      {{ "common.notFoundHelp" | translate }}
                    </p>
                  </div>
                </div>
                }
              </div>
            </div>
            } @placeholder {

            <!-- *loading -->
            <div class="tw-w-full tw-h-full tw-flex-center">
              <div
                class="tw-w-4/5 md:tw-min-h-[60vh] tw-min-h-[50vh] tw-flex-center"
              >
                <div class="tw-animate-pulse tw-flex tw-space-x-4 tw-w-full">
                  <div class="tw-flex-1 tw-space-y-6 tw-py-1">
                    <!-- title loading -->
                    <div
                      class="tw-h-6 tw-w-1/3 tw-bg-gray-200 dark:tw-bg-[#303048] dark:tw-opacity-70 tw-rounded"
                    ></div>

                    <!-- text loading  -->
                    <div class="lg:tw-space-y-5 tw-space-y-3">
                      @for (item of preloadingRowCount; track $index) {
                      <div
                        class="lg:tw-h-6 tw-h-4 tw-bg-gray-200 dark:tw-bg-[#303048] dark:tw-opacity-70 tw-rounded"
                      ></div>
                      }
                    </div>

                    <!-- video image and file loading -->
                    <div
                      class="tw-w-full tw-flex tw-space-x-4 tw-space-x-reverse"
                    >
                      <div
                        class="md:tw-h-44 tw-h-28 tw-w-1/3 tw-rounded tw-bg-gray-200 dark:tw-bg-[#303048] dark:tw-opacity-70"
                      >
                        <div class="tw-w-full tw-h-full tw-flex-center">
                          <i
                            class="mdi mdi-movie-open-outline lg:tw-text-6xl tw-text-4xl tw-text-white dark:!tw-text-gray-500"
                          ></i>
                        </div>
                      </div>

                      <div
                        class="md:tw-h-44 tw-h-28 tw-w-1/3 tw-rounded tw-bg-gray-200 dark:tw-bg-[#303048] dark:tw-opacity-70"
                      >
                        <div class="tw-w-full tw-h-full tw-flex-center">
                          <i
                            class="mdi mdi-file lg:tw-text-6xl tw-text-4xl tw-text-white dark:!tw-text-gray-500"
                          ></i>
                        </div>
                      </div>

                      <div
                        class="md:tw-h-44 tw-h-28 tw-w-1/3 tw-rounded tw-bg-gray-200 dark:tw-bg-[#303048] dark:tw-opacity-70"
                      >
                        <div class="tw-w-full tw-h-full tw-flex-center">
                          <i
                            class="mdi mdi-image lg:tw-text-6xl tw-text-4xl tw-text-white dark:!tw-text-gray-500"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
          </fieldset>
        </section>

        <!--* help files -->
        @if(model.menuHelps?.length && !loading){
        <section class="md:tw-w-3/4 tw-w-full tw-mt-5">
          <fieldset class="tw-min-w-[1px] tw-flex-center">
            <legend>
              {{ "common.attachment" | translate }}
            </legend>

            <div class="tw-flex tw-flex-col tw-mt-6 tw-w-4/5 tw-py-10">
              @for (filesList of categorizedFiles; track $index) {
              @if(filesList?.files?.length) {
              <!-- بخش مربوط به هر نوع فایل -->
              <details class="py-2" [open]="true">
                <!-- عنوان هر دسته -->
                <summary
                  class="active:tw-outline-none dark:tw-text-gray-300 focus:tw-outline-none tw-font-bold tw-mb-2 tw-text-[18px] tw-text-primary-700 tw-text-right"
                >
                  {{ filesList?.type | enumToText : HelpFileTypesEnumValues }}
                </summary>
                @for (file of filesList?.files; track $index) {
                <div
                  class="tw-mb-4 tw-flex-between tw-px-6 tw-py-3 tw-rounded tw-w-full tw-border dark:tw-border-gray-600"
                >
                  <div class="tw-flex tw-items-center">
                    <!-- file -->
                    @switch (file.type) {

                    <!-- file -->
                    @case (helpFileType.File) {
                    <img
                      class="sm:tw-w-12 sm:tw-h-12 tw-w-10 tw-h-10 tw-object-contain"
                      src="/assets/media/svg/files/file.svg"
                      [alt]="file?.title"
                    />
                    }

                    <!-- pdf -->
                    @case(helpFileType.Pdf) {
                    <img
                      [matTooltip]="'common.show' | translate"
                      (click)="downloadFile(apiUrl + '/' + file?.filePath)"
                      class="sm:tw-w-12 sm:tw-h-12 tw-w-10 tw-h-10 tw-object-contain tw-cursor-pointer"
                      src="/assets/media/svg/files/pdf-file-svgrepo-com.svg"
                      [alt]="file?.title"
                    />
                    }

                    <!-- image -->
                    @case (helpFileType.Image) {
                    <img
                      [matTooltip]="'common.show' | translate"
                      (click)="onOpenImageGalley(file?.filePath)"
                      class="sm:tw-w-12 sm:tw-h-12 tw-w-10 tw-h-10 tw-border dark:tw-border-gray-500 tw-rounded-md tw-object-contain tw-cursor-pointer"
                      [src]="apiUrl + '/' + file?.filePath"
                      [alt]="file?.title"
                    />
                    }

                    <!-- video -->
                    @case (helpFileType.Video) {
                    <div
                      class="tw-relative tw-cursor-pointer"
                      (click)="downloadFile(apiUrl + '/' + file?.filePath)"
                    >
                      <div
                        class="tw-absolute tw-bg-gray-600/60 dark:tw-bg-gray-600/40 tw-flex-center tw-inset-0 tw-z-1 tw-rounded-md"
                      >
                        <i
                          class="mdi mdi-play-circle mdi-20px tw-text-white dark:!tw-text-gray-300 tw-z-[2]"
                        ></i>
                      </div>
                      <video
                        [matTooltip]="'common.show' | translate"
                        class="tw-inline-block sm:tw-w-12 sm:tw-h-12 tw-w-10 tw-h-10 tw-object-cover tw-rounded-md"
                        [src]="apiUrl + '/' + file?.filePath"
                      ></video>
                    </div>
                    } }

                    <!-- title -->
                    <span
                      class="tw-px-3 tw-text-gray-500 dark:tw-text-gray-300 md:tw-text-lg tw-text-base tw-opacity-90 tw-font-medium"
                    >
                      {{ file?.title }}
                    </span>
                  </div>

                  <!-- download btn -->
                  <i
                    [matTooltip]="'common.download' | translate"
                    (click)="downloadFile(apiUrl + '/' + file?.filePath)"
                    class="mdi mdi-download tw-text-gray-400 dark:!tw-text-gray-400 md:tw-text-4xl tw-text-2xl tw-cursor-pointer hover:tw-text-gray-500 dark:hover:!tw-text-gray-300"
                  ></i>
                </div>
                }
              </details>
              } }
            </div>
          </fieldset>
        </section>
        }
      </div>
    </div>
  </div>
</app-page-body>
